// React-
import React, { lazy } from 'react';

const MaterialTracking = lazy(() => import('./index'));

const MaterialTrackingRoute = () => {
    return [
        {
            key: 'material_tracking',
            path: '/material_tracking',
            component: <MaterialTracking />,
        },
    ];
};

export default MaterialTrackingRoute;
